import React from 'react';

import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material';
import DebouncedText from '../../editors/mui/DebouncedText';

const styles = {
  searchTextField: {
    root: {
      padding: '5px',
      width: '100%',
      fontSize: 12,
      border: 'none',
    },
    input: {
      color: '#333',
    },
    inputHint: {
      fontSize: 12,
      color: '#ADBDCC',
      lineHeight: '24px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      height: 'auto',
    },
  },
};
class SchemaBrowserSearch extends React.Component {
  render() {
    const { style, searchText, hintText, onChange } = this.props;
    return (
      <div style={style.root}>
        <SearchIcon fontSize="large" style={style.searchIcon} />
        <DebouncedText
          rootStyle={styles.searchTextField.root}
          inputTheme="light"
          placeholder={hintText || 'Search attributes'}
          onChange={onChange}
          value={searchText ? searchText : ''}
          debounceTimeMs={400}
        />
        {searchText && searchText !== '' && (
          <CloseIcon
            fontSize="large"
            style={style.closeIcon}
            onClick={(e) => {
              e.preventDefault();
              onChange('');
            }}
          />
        )}
      </div>
    );
  }
}

export default SchemaBrowserSearch;
